/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions(value) {
    if (!('Signature' in value) || value['Signature'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ApplicationScopedId': json['ApplicationScopedId'] == null ? undefined : json['ApplicationScopedId'],
        'PlayerId': json['PlayerId'] == null ? undefined : json['PlayerId'],
        'Signature': json['Signature'],
        'ApplicationScopedIdSignature': json['ApplicationScopedIdSignature'] == null ? undefined : json['ApplicationScopedIdSignature'],
        'ExistingAccountOnly': json['ExistingAccountOnly'] == null ? undefined : json['ExistingAccountOnly'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ApplicationScopedId': value['ApplicationScopedId'],
        'PlayerId': value['PlayerId'],
        'Signature': value['Signature'],
        'ApplicationScopedIdSignature': value['ApplicationScopedIdSignature'],
        'ExistingAccountOnly': value['ExistingAccountOnly'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions.js.map